import React from "react";
import PortalSection from "../../PortalSection";
import { Helmet } from "react-helmet";

export default function Blackjack() {
  const curDate = new Date();
  const topPar = {
    h4: `Explore the Legacy and Future of Blackjack in UK Casinos  - ${curDate.getFullYear()}`,
    p: "Blackjack is a classic casino game that offers a perfect balance of skill, strategy, and luck. Known for its simple rules and exciting gameplay, Blackjack remains a top favorite in UK casinos. Whether you're new to the game or a seasoned pro, it's all about making the right decisions to beat the dealer and win big.",
  };

  const par1 = {
    id: "par-1",
    h4: "🃏 What Is Blackjack?",
    p: "Blackjack is a card game where the goal is to get a hand value of 21 or as close to it as possible, without going over. Players compete against the dealer, not other players, and must decide whether to 'hit' (draw another card) or 'stand' (keep their current hand). The simplicity of the game, combined with the chance for strategy, makes it a thrilling option for casino enthusiasts.",
  };

  const par2 = {
    id: "par-2",
    h4: "💥 Why Is Blackjack So Popular?",
    ul: [
      "Strategic Gameplay: While luck plays a part, Blackjack is one of the few casino games where players can influence the outcome with strategy and decision-making.",
      "Fast-Paced Action: The game moves quickly, with multiple rounds played in a short time, keeping players engaged.",
      "Great Odds: Blackjack offers one of the lowest house edges in the casino, making it attractive for players seeking a game where skill can improve their chances.",
    ],
  };

  const par3 = {
    id: "par-3",
    h4: "🌟 Top Blackjack Games of 2025",
    p: "From live dealer Blackjack to unique variants like Blackjack Switch, UK casinos offer a variety of exciting ways to enjoy this classic game.",
    ul: [
      "Classic Blackjack: The traditional version where players aim for 21, using standard rules.",
      "European Blackjack: A version where the dealer only gets one card at first, adding an extra layer of strategy.",
      "Live Dealer Blackjack: Enjoy a real casino experience from home, with live dealers streaming the action in real-time.",
      "Blackjack Switch: A fun variation where players can swap cards between two hands to improve their chances of winning.",
    ],
    end: "Ready to test your Blackjack skills? Play at top UK casinos and try your luck at beating the dealer. Play responsibly!",
  };

  const meta = {
    title: `Blackjack in UK Casinos: History, Strategy & Innovation (${curDate.getFullYear()})`,
    description: `Explore the rich history and modern innovations of blackjack in UK casinos. Learn how this iconic game blends skill and chance across physical and digital tables in ${curDate.getFullYear()}. Play smart, play safe!`,
  };

  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
      </Helmet>

      <PortalSection />

      <div className="w-100 text-bg-dark text-white pt-5 pb-5 mt-3 information">
        <div className="mt-4">
          <h4>{topPar.h4}</h4>
          {topPar.p.split("\n").map((pi, i) => (
            <p key={i}>{pi}</p>
          ))}
        </div>

        <div id={par1.id} className="mt-4">
          <h4>{par1.h4}</h4>
          <p>{par1.p}</p>
        </div>

        <div id={par2.id} className="mt-4">
          <h4>{par2.h4}</h4>
          <ul>
            {par2.ul.map((li, i) => {
              const [title, text] = li.split(":");

              return (
                <li key={i}>
                  <span className="fw-bold">{title}:</span> {text}
                </li>
              );
            })}
          </ul>
        </div>

        <div id={par3.id} className="mt-4">
          <h4>{par3.h4}</h4>
          <p>{par3.p}</p>
          {par3.ul.map((li, i) => {
            const [title, text] = li.split(":");

            return (
              <li key={i}>
                <span className="fw-bold">{title}:</span> {text}
              </li>
            );
          })}
          <p>{par3.end}</p>
        </div>
      </div>
    </>
  );
}
